import { addHours, addWeeks, format, getDay, getHours, setDay, setHours, setMinutes } from 'date-fns';
import styled from 'styled-components';
import React, { useState } from 'react';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';
import { ACSS, Button, H4, H5, H6, IconCalendar, P } from '@upsolve/ui';

import withViewportWatch from '../analytics/withViewportWatch';
import trackComponentImpression from '../analytics/trackComponentImpression';
import trackComponentAction from '../analytics/trackComponentAction';

const trackingProps = {
  componentName: 'CTAWebinar',
  componentVersion: 0,
};

// CALENDAR EVENT
const weekToAdd = [4, 5, 6].includes(getDay(new Date())) || (getDay(new Date()) === 3 && getHours(new Date()) >= 17) ? 1 : 0; // Check if we passed this week
const startDateTime = setMinutes(setHours(setDay(addWeeks(new Date(), weekToAdd), 3), 17), 0); // Next Wednesday at 5PM EST
const endDateTime = addHours(startDateTime, 1); // 1 hour long
const duration = 1; // 1 hour long
const event = {
  title: 'Upsolve Q&A Town Hall',
  description: 'Join the Upsolve team online for open question and answers. Our Google Hangout link:\nhttp://meet.google.com/wbf-datm-pdz',
  location: 'Online',
  startDatetime: format(startDateTime, "yyyyMMdd'T'kkmmss"),
  duration,
  endDatetime: format(endDateTime, "yyyyMMdd'T'kkmmss"),
  timezone: 'ET',
};

// ADD TO CALENDAR COMPONENTS
const AddToCalendarButton = ({ children, onClick }) => (
  <StyledAddToCalendarButton onClick={onClick}>
    <IconCalendar /> Add to Calendar
  </StyledAddToCalendarButton>
)
const AddToCalendarDropdown = ({ children }) => (
  <StyledAddToCalendarDropdown>{children}</StyledAddToCalendarDropdown>
);
const AddToCalendar = AddToCalendarHOC(AddToCalendarButton, AddToCalendarDropdown);

// CTA
const CTAWebinar = (props) => {
  // Impression Tracking
  const [actionTracked, setActionTracked] = useState(false);
  const [impressionTracked, setImpressionTracked] = useState(false)
  if (props.isInViewport && !impressionTracked) {
    setImpressionTracked(true);
    props.stopWatcher();
    trackComponentImpression(trackingProps);
  }

  return (
    <StyledCTAWebinar dataTestId={props.dataTestId}>
      <H4>Weekly Upsolve Q&A @ <u>Wednesday 5pm EST</u></H4>
      <P><b>Have questions about the Upsolve process? Ask our team live online!</b></P>
      <div className="add" onClick={() => {
        // We can't add an onClick to HOC, so tracking click via the surrounding div
        if (!actionTracked) {
          trackComponentAction({ ...trackingProps, actionId: 'ctaWebinar.addToCalendar', actionMethod: 'click' })
          setActionTracked(true);
        }
      }}>
        <AddToCalendar className="add-to-calendar-button" event={event} />
      </div>
    </StyledCTAWebinar>
  )
};

const StyledAddToCalendarButton = styled(Button)`
  svg {
    max-height: 100%;
    margin-right: 4px;
    position: relative;
    top: -1px;
  }
`;

const StyledAddToCalendarDropdown = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  a {
    ${ACSS}
    text-align: center;
    background: white;
    padding: 0.5em 0.25em;
    border: 1px solid ${props => props.theme.colors.white[300]};
  }
`;

const StyledCTAWebinar = styled.div.attrs(props => ({
  'data-test-id': props.dataTestId,
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em;
  h4 {
    text-align: center;
    margin: 0;
    padding: 0 0.5em;
  }
  p {
    text-align: center;
    padding: 0 0.5em;
  }
  .message {
    background: white;
    border-radius: 12px;
    padding: 0.5em;
  }
  .add {
    .add-to-calendar-button {
      display: flex;
      flex-direction: column;
    }
  }

  @media(max-width: 45em) {
    padding: 0;
  }
`;

export default withViewportWatch(CTAWebinar);
